import { temAcesso } from '@/shared/auth/temAcesso'

const Modelos = () => import('./Modelos.vue')
// const TiposMovimentosForm = () => import('./TiposMovimentosForm.vue')

export default {
    path: 'modelos',
    name: 'Modelos',
    component: Modelos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-MODELOS-00')) {
            next()
        }
    },
    children: [
        // {
        //     path: 'inserir',
        //     name: 'TiposMovimentos_Inserir',
        //     component: TiposMovimentosForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('ADMIN-TIPOMOV-01')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':codMov',
        //     name: 'TiposMovimentos_Detalhar',
        //     component: TiposMovimentosForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('ADMIN-TIPOMOV-01')) {
        //             next()
        //         }
        //     }
        // }
    ]
}
